"use strict";

function FilterByController($rootScope) {
    var _this = this;

    function setFilters() {
        _this.allFilters = _this.filterMethod();
    }

    setFilters();

    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        setFilters();
    });

    this.$onDestroy = function() {
        unregisterLanguageChanged();
    };

}

function FilterByTagController($rootScope) {
    var _this = this;
    var service = _this.service;

    function setFilters() {
        _this.allFilters = service.queryTags();
    }

    setFilters();

    var unregisterLanguageChanged = $rootScope.$on("LanguageChanged", function(evt, new_locale, new_language) {
        setFilters();
    });

    this.$onDestroy = function() {
        unregisterLanguageChanged();
    };
}

angular.module("vendor")
.component("filterBy", {
    templateUrl: require("./filter-by.component.html"),
    controller: FilterByController,
    controllerAs: "filterByCtrl",
    bindings: {
        filterMethod: "&",
        onChangeMethod: "=",
        defaultValue: "=",
        defaultText: "="
    }
});

angular.module("vendor")
.component("filterByTag", {
    templateUrl: require("./filter-by-tag.component.html"),
    controller: FilterByTagController,
    controllerAs: "filterByCtrl",
    bindings: {
        service: "<",
        onChangeMethod: "=",
        defaultValue: "=",
        defaultText: "="
    }
});



//////////////////
// WEBPACK FOOTER
// ./vendor/app-core/filter-by/filter-by.component.js
// module id = 798
// module chunks = 0